class BundleForm extends HTMLElement {
  constructor() {
    super();
    this.bindMethods();
  }

  bindMethods() {
    const methods = [
      'handleSubmit', 'handleIncrease', 'handleDecrease',
      'handleIncreaseVoo', 'handleDecreaseVoo',
      'handleIncreaseHotel', 'handleDecreaseHotel',
      'updatePriceDisplay', 'updateSummary', 'updateMaxQuantities',
      'goToNextStep', 'goToStep', 'checkStepCompletion',
      'setupStepHeaders', 'getProductAvailability',
      'findNextAvailableStep', 'calculateTotalBeds',
      'checkVariantInventory', 'updateIngressoAvailability',
      'updateHotelAvailability', 'updateVooAvailability',
      'updateTicketPreview', 'updateIngressoConfirmButton', 'updateVooConfirmButton',
      'setMaxQuantityLimit', 'setupFloatingButton', 'updateFloatingSummary',
      'toggleFloatingResumo', 'setupFloatingButtons', 'handleFloatingAddToCart',
      'updateFloatingButtons', 'setupNightsSelection', 'filterHotelVariantsByNights',
      'updateNightsPreview', 'updateNightsConfirmButton', 'calculateNightsPrice',
      'updateNightsSummary', 'updateNightsAvailability', 'updateNightsFloatingSummary',
      'updateRoomConfirmButton', 'syncHotelSource'
    ];

    methods.forEach(method => {
      if (this[method]) this[method] = this[method].bind(this);
    });
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.initializeForm();
    this.setupEventListeners();
    this.setupFloatingButton();
    this.setupFloatingButtons();

    const primeiraEtapa = this.steps[0];
    if (primeiraEtapa) {
      primeiraEtapa.classList.add('visited');
      const header = primeiraEtapa.querySelector('h3');
      if (header) {
        header.style.cursor = 'pointer';
        header.onclick = () => this.goToStep(0);
      }
    }

    this.updateMaxQuantities();
    this.updatePriceDisplay();
    this.updateSummary();
    this.syncHotelSource();

    if (this.hasIngresso) {
      this.updateIngressoConfirmButton();
    }

    if (this.hasNights) {
      this.updateNightsConfirmButton();
    }

    if (this.hasHotel && !this.hasNights) {
      this.updateRoomConfirmButton();
    }

    if (this.hasVoo) {
      this.updateVooConfirmButton();
    }

    const checkInventory = this.querySelector('#check_inventory');
    if (checkInventory && checkInventory.value === 'true') {
      this.checkAllInventory();
    }
  }

  initializeForm() {
    this.getProductAvailability();

    const mainBundleEl = document.getElementById('asb26-main-bundle-product');
    this.productId = mainBundleEl ? mainBundleEl.getAttribute('data-product-id') : null;
    this.quantityInput = this.form.querySelector('input[name="quantidade"]');
    this.quantityVooInputs = this.hasVoo ? this.form.querySelectorAll('input[name="quantidade_voo"]') : [];
    this.hotelQuantityInputs = this.hasHotel ? this.form.querySelectorAll('.hotel-quantity') : [];
    this.addButton = this.form.querySelector('#add-bundle');

    this.setMaxQuantityLimit();

    if (this.hasVoo) {
      this.vooVariantId = parseInt(this.querySelector('#voo_variant_id').value) || 0;
      this.vooVariantPrice = parseInt(this.querySelector('#voo_variant_price').value) || 0;
      this.vooVariantTitle = this.querySelector('#voo_variant_title').value || '';
    }

    this.summaryIngresso = this.hasIngresso ? this.form.querySelector('.summary-ingresso') : null;
    this.summaryNights = this.hasNights ? this.form.querySelector('.summary-nights') : null;
    this.summaryHotel = this.hasHotel ? this.form.querySelector('.summary-hotel') : null;
    this.summaryVoo = this.hasVoo ? this.form.querySelector('.summary-voo') : null;

    this.steps = this.form.querySelectorAll('.bundle-step:not(.hidden)');
    this.currentStepIndex = 0;
    this.visitedSteps = [0];

    if (this.steps[0] && !this.steps[0].classList.contains('visited')) {
      this.steps[0].classList.add('visited');
    }
  }

  // Funções setters - Setup

  setupEventListeners() {
    this.addButton?.addEventListener('click', this.handleSubmit);

    const increaseBtn = this.form.querySelector('.increase-qty');
    const decreaseBtn = this.form.querySelector('.decrease-qty');
    increaseBtn?.addEventListener('click', this.handleIncrease);
    decreaseBtn?.addEventListener('click', this.handleDecrease);

    this.setupQuantityLimitDismiss();

    this.setupVooEventListeners();

    this.setupHotelEventListeners();

    this.setupNightsSelection();

    this.quantityInput.addEventListener('change', this.updateMaxQuantities);

    if (this.hasIngresso) {
      this.form.querySelectorAll('input[name="variant_ingresso"]').forEach(input => {
        input.addEventListener('change', () => {
          this.setMaxQuantityLimit();
          this.syncHotelSource();
          this.updatePriceDisplay();
          this.updateSummary();
          this.updateTicketPreview(input);
          this.updateIngressoConfirmButton();
        });
      });
    }

    if (this.hasHotel) {
      this.form.querySelectorAll('input[name="hotel_type"]').forEach(input => {
        input.addEventListener('change', () => {
          this.updatePriceDisplay();
          this.updateSummary();
          this.updateHotelConfirmButton();
          this.updateHotelPreview(input);
        });
      });
    }

    this.form.querySelectorAll('.confirm-step').forEach(button => {
      button.addEventListener('click', () => {
        if (button.id !== 'add-bundle') {
          this.goToNextStep();
        }
      });
    });

    this.setupStepHeaders();
  }

  setupVooEventListeners() {
    if (!this.hasVoo) return;

    const increaseVooBtns = this.form.querySelectorAll('.increase-qty-voo');
    const decreaseVooBtns = this.form.querySelectorAll('.decrease-qty-voo');

    increaseVooBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const quantityInput = e.target.closest('.voo-option').querySelector('.voo-quantity');
        this.handleIncreaseVoo(quantityInput);
      });
    });

    decreaseVooBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const quantityInput = e.target.closest('.voo-option').querySelector('.voo-quantity');
        this.handleDecreaseVoo(quantityInput);
      });
    });

    this.quantityVooInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updatePriceDisplay();
        this.updateSummary();
        this.updateVooConfirmButton();
      });
    });

    const vooTypeInputs = this.form.querySelectorAll('input[name="voo_type"]');
    vooTypeInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked && input.value === 'no_voo') {
          this.quantityVooInputs.forEach(qtyInput => {
            qtyInput.value = 0;
          });
          this.updatePriceDisplay();
          this.updateSummary();
        }
        this.updateVooConfirmButton();
      });
    });

    this.setupVooSelection();
  }

  setupVooSelection() {
    if (!this.hasVoo) return;

    const vooOptions = this.form.querySelectorAll('.voo-option');
    const maxQuantity = parseInt(this.form.querySelector('input[name="quantidade"]').value) || 1;

    vooOptions.forEach(option => {
      const variantData = option.querySelector('.voo-variant-data');
      const maxVoos = parseInt(variantData.dataset.inventory) || 0;
      const shouldShow = maxVoos >= maxQuantity;
      option.style.display = shouldShow ? 'block' : 'none';

      if (!shouldShow) {
        const quantityInput = option.querySelector('.voo-quantity');
        if (quantityInput) quantityInput.value = 0;
      }
    });

    this.updatePriceDisplay();
    this.updateSummary();
    this.updateVooConfirmButton();

    const currentStep = this.steps[this.currentStepIndex];
    if (currentStep && currentStep.dataset.step === '5') {
      this.goToNextStep();
    }
  }

  setupHotelEventListeners() {
    if (!this.hasHotel) return;

    const increaseHotelBtns = this.form.querySelectorAll('.increase-qty-hotel');
    const decreaseHotelBtns = this.form.querySelectorAll('.decrease-qty-hotel');

    increaseHotelBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const quantityInput = e.target.closest('.hotel-option').querySelector('.hotel-quantity');
        this.handleIncreaseHotel(quantityInput);
      });
    });

    decreaseHotelBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const quantityInput = e.target.closest('.hotel-option').querySelector('.hotel-quantity');
        this.handleDecreaseHotel(quantityInput);
      });
    });

    this.hotelQuantityInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updatePriceDisplay();
        this.updateSummary();
        this.updateRoomConfirmButton();
      });
    });

    this.setupHotelSelection();
  }

  setupNightsSelection() {
    if (!this.hasNights) return;

    const nightsTypeInputs = this.form.querySelectorAll('input[name="nights_type"]');
    nightsTypeInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          // Use nights-display for filtering hotels (only nights part)
          const selectedTitle = input.dataset.nightsDisplay || input.dataset.title.split(' / ')[0];
          this.filterHotelVariantsByNights(selectedTitle);

          this.updateNightsPreview(input);
          this.updatePriceDisplay();
          this.updateSummary();
          this.updateNightsConfirmButton();
        }
      });
    });
  }

  setupHotelSelection() {
    const hotelTypeInputs = this.form.querySelectorAll('input[name="hotel_type"]');
    const hotelOptions = this.form.querySelectorAll('.hotel-option');

    hotelTypeInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          const selectedHotel = input.value;

          this.hotelQuantityInputs.forEach(input => {
            input.value = 0;
          });

          if (selectedHotel === 'no_hotel') {
            hotelOptions.forEach(option => {
              option.style.display = 'none';
            });

            this.updatePriceDisplay();
            this.updateSummary();
            this.updateHotelConfirmButton();
            this.updateRoomConfirmButton();
          } else {
            // Se tem noites, filtrar também por noites
            if (this.hasNights) {
              const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
              if (nightsInput) {
                const selectedNightsTitle = nightsInput.dataset.nightsDisplay || nightsInput.dataset.title.split(' / ')[0];
                hotelOptions.forEach(option => {
                  const variantData = option.querySelector('.hotel-variant-data');
                  const nightsValue = variantData ? variantData.dataset.nights : null;
                  const matchesHotel = option.dataset.hotel === selectedHotel;
                  const matchesNights = !nightsValue || nightsValue === selectedNightsTitle;
                  option.style.display = (matchesHotel && matchesNights && this.isActiveHotelSource(option)) ? 'block' : 'none';
                });
              } else {
                hotelOptions.forEach(option => {
                  option.style.display = 'none';
                });
              }
            } else {
              hotelOptions.forEach(option => {
                option.style.display = (option.dataset.hotel === selectedHotel && this.isActiveHotelSource(option)) ? 'block' : 'none';
              });
            }

            this.updatePriceDisplay();
            this.updateSummary();
            this.updateHotelConfirmButton();
            this.updateRoomConfirmButton();
          }
        }
      });
    });
  }

  updateHotelConfirmButton() {
    if (!this.hasHotel) return;

    const hotelStep = this.form.querySelector('.bundle-step[data-step="3"]');
    if (!hotelStep) return;

    const confirmButton = hotelStep.querySelector('.confirm-step');
    if (!confirmButton) return;

    const selectedInput = this.form.querySelector('input[name="hotel_type"]:checked');

    if (selectedInput) {
      const isSoldOut = selectedInput.dataset.soldOut === 'true';
      const isNoHotel = selectedInput.value === 'no_hotel';

      if (isSoldOut) {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Hotel esgotado';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      } else if (isNoHotel) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      } else {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar hotel';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      }
    } else {
      confirmButton.disabled = true;
      confirmButton.textContent = 'Selecione um hotel';
      confirmButton.style.opacity = '0.5';
      confirmButton.style.cursor = 'not-allowed';
    }
  }

  updateRoomConfirmButton() {
    if (!this.hasHotel || this.hasNights) return;

    const roomStep = this.form.querySelector('.bundle-hotel-config[data-step="4"]');
    if (!roomStep) return;

    const confirmButton = roomStep.querySelector('.confirm-room-step');
    if (!confirmButton) return;

    const totalBeds = this.calculateTotalBeds();
    const maxQuantity = parseInt(this.quantityInput.value) || 0;
    const hasEnoughBeds = maxQuantity > 0 && totalBeds >= maxQuantity;

    confirmButton.disabled = !hasEnoughBeds;

    if (hasEnoughBeds) {
      confirmButton.textContent = 'Confirmar quartos';
    } else if (totalBeds === 0) {
      confirmButton.textContent = 'Selecione os quartos';
    } else {
      const missingBeds = maxQuantity - totalBeds;
      confirmButton.textContent = `${missingBeds === 1 ? 'Falta' : 'Faltam'} ${missingBeds} ${missingBeds === 1 ? 'cama' : 'camas'}`;
    }
  }

  setupStepHeaders() {
    this.steps.forEach((step, index) => {
      const header = step.querySelector('h3');
      if (!header) return;

      header.style.cursor = 'pointer';

      header.addEventListener('click', () => {
        if (index < this.currentStepIndex || this.visitedSteps.includes(index)) {
          this.goToStep(index);
        }
      });

      const editIcon = header.querySelector('.edit-step-icon');
      if (editIcon) {
        editIcon.addEventListener('click', (e) => {
          e.stopPropagation();
          if (index < this.currentStepIndex || this.visitedSteps.includes(index)) {
            this.goToStep(index);
          }
        });
      }
    });

    if (this.steps[0]) {
      this.steps[0].classList.add('visited');
    }
  }

  setupFloatingButton() {
    const floatingButton = document.querySelector('.ec-bundle-product-floating-button');
    if (floatingButton) {
      floatingButton.addEventListener('click', this.toggleFloatingResumo);
    }
  }

  setupFloatingButtons() {
    const addToCartFloating = document.querySelector('#add-to-cart-bundle-floating');
    const closeButton = document.querySelector('.floating-drawer-close');

    if (addToCartFloating) {
      addToCartFloating.addEventListener('click', this.handleFloatingAddToCart);
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
        if (floatingResumo) {
          floatingResumo.classList.remove('show');
        }
      });
    }
  }

  setMaxQuantityLimit() {
    if (!this.quantityInput) return;
    if (!this.hasIngresso && !this.hasHotel && !this.hasVoo) return;

    let maxInventory = 0;
    let limitLabel = 'ingressos';

    // Com ingresso em jogo o limite continua vindo do estoque de ingressos (um por pessoa).
    // Sem ingresso vinculado, ou com ele dispensado, o limite passa a vir de hotel/aéreo.
    if (this.hasIngresso && !this.isIngressoSkipped()) {
      maxInventory = this.getMaxIngressoInventory();
    } else {
      const hotelCapacity = this.getMaxHotelCapacity();
      const vooInventory = this.getMaxVooInventory();

      maxInventory = Math.max(hotelCapacity, vooInventory);
      limitLabel = hotelCapacity >= vooInventory ? 'pessoas' : 'passagens';
    }

    if (maxInventory === 0) {
      maxInventory = 1;
    }

    this.quantityInput.setAttribute('max', maxInventory);

    const limitInfo = this.form.querySelector('.quantity-limit-info');
    if (limitInfo && maxInventory > 1) {
      limitInfo.textContent = `Máximo disponível: ${maxInventory} ${limitLabel}`;
      limitInfo.style.display = 'block';
    } else if (limitInfo) {
      limitInfo.style.display = 'none';
    }

    const currentValue = parseInt(this.quantityInput.value) || 1;
    if (currentValue > maxInventory) {
      this.quantityInput.value = maxInventory;
      this.updateMaxQuantities();
      this.updatePriceDisplay();
      this.updateSummary();
    }
  }

  getMaxIngressoInventory() {
    if (!this.hasIngresso) return 0;

    let maxInventory = 0;

    this.form.querySelectorAll('input[name="variant_ingresso"]').forEach(input => {
      if (input.value === 'no_ingresso') return;

      const inventory = parseInt(input.dataset.inventory) || 0;
      const available = input.dataset.available === 'true';

      if (available && inventory > maxInventory) {
        maxInventory = inventory;
      }
    });

    return maxInventory;
  }

  getMaxHotelCapacity() {
    if (!this.hasHotel) return 0;

    // Quartos de hotéis diferentes não se somam: a capacidade é a do hotel que acomoda mais gente.
    const capacityByHotel = {};

    this.form.querySelectorAll('.hotel-option').forEach(option => {
      if (!this.isActiveHotelSource(option)) return;

      const variantData = option.querySelector('.hotel-variant-data');
      if (!variantData || variantData.dataset.available !== 'true') return;

      const inventory = parseInt(variantData.dataset.inventory) || 0;
      const beds = parseInt(variantData.dataset.beds) || 1;
      const hotelName = option.dataset.hotel || '';

      capacityByHotel[hotelName] = (capacityByHotel[hotelName] || 0) + (inventory * beds);
    });

    return Object.values(capacityByHotel).reduce((max, capacity) => Math.max(max, capacity), 0);
  }

  getMaxVooInventory() {
    if (!this.hasVoo) return 0;

    let maxInventory = 0;

    this.form.querySelectorAll('.voo-variant-data').forEach(variantData => {
      if (variantData.dataset.available !== 'true') return;

      const inventory = parseInt(variantData.dataset.inventory) || 0;
      if (inventory > maxInventory) {
        maxInventory = inventory;
      }
    });

    return maxInventory;
  }

  disconnectedCallback() {
    this.addButton?.removeEventListener('click', this.handleSubmit);
  }

  getProductAvailability() {
    const hasIngresso = this.querySelector('#has_ingresso');
    const hasNights = this.querySelector('#has_noites');
    const hasHotel = this.querySelector('#has_hotel');
    const hasVoo = this.querySelector('#has_voo');
    const ingressoRequired = this.querySelector('#ingresso_required');
    const hotelRequired = this.querySelector('#hotel_required');
    const vooRequired = this.querySelector('#voo_required');
    const quantidadeParcelas = this.querySelector('#quantidade_parcelas');
    const initialProductPrice = this.querySelector('#initial_product_price');

    this.hasIngresso = hasIngresso ? hasIngresso.value === 'true' : false;
    this.hasNights = hasNights ? hasNights.value === 'true' : false;
    this.hasHotel = hasHotel ? hasHotel.value === 'true' : false;
    this.hasNoTicketHotel = this.querySelector('#has_no_ticket_hotel')?.value === 'true';
    this.hasVoo = hasVoo ? hasVoo.value === 'true' : false;
    this.ingressoRequired = ingressoRequired ? ingressoRequired.value === 'true' : true;
    this.hotelRequired = hotelRequired ? hotelRequired.value === 'true' : true;
    this.vooRequired = vooRequired ? vooRequired.value === 'true' : true;
    this.quantidadeParcelas = quantidadeParcelas ? parseInt(quantidadeParcelas.value) || 10 : 10;
    this.initialProductPrice = initialProductPrice ? parseInt(initialProductPrice.value) || 0 : 0;
  }

  isIngressoSkipped() {
    return !!this.form.querySelector('input[name="variant_ingresso"][value="no_ingresso"]:checked');
  }

  getActiveHotelSource() {
    if (this.isIngressoSkipped() && this.hasNoTicketHotel) return 'no-ticket';
    return 'default';
  }

  isActiveHotelSource(el) {
    if (!el) return false;
    const source = el.dataset.hotelSource;
    if (!source) return true;
    return source === this.getActiveHotelSource();
  }

  syncHotelSource() {
    if (!this.hasHotel) return;

    const source = this.getActiveHotelSource();

    this.form.querySelectorAll('label.bundle-option[data-hotel-source]').forEach(label => {
      const isActive = label.dataset.hotelSource === source;
      const input = label.querySelector('input[name="hotel_type"]');
      label.style.display = isActive ? '' : 'none';
      if (!isActive && input) input.checked = false;
    });

    this.form.querySelectorAll('.hotel-section[data-hotel-source]').forEach(section => {
      section.style.display = section.dataset.hotelSource === source ? '' : 'none';
    });

    this.form.querySelectorAll('.hotel-option[data-hotel-source]').forEach(option => {
      if (option.dataset.hotelSource !== source) {
        option.style.display = 'none';
        const qty = option.querySelector('.hotel-quantity');
        if (qty) qty.value = 0;
      }
    });

    this.form.querySelectorAll('.ec-hotel-image-preview[data-hotel-source]').forEach(preview => {
      if (preview.dataset.hotelSource !== source) {
        preview.style.display = 'none';
      }
    });

    const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
    if (this.hasNights && nightsInput) {
      const selectedTitle = nightsInput.dataset.nightsDisplay || nightsInput.dataset.title.split(' / ')[0];
      this.filterHotelVariantsByNights(selectedTitle);
    }

    const placeholder = this.form.querySelector('.ec-hotel-preview-placeholder');
    if (placeholder) placeholder.style.display = 'block';

    this.updateHotelConfirmButton();
    this.updateRoomConfirmButton();
    this.setMaxQuantityLimit();
  }

  getSelectedIngresso() {
    const selected = this.form.querySelector('input[name="variant_ingresso"]:checked');
    return selected && selected.value !== 'no_ingresso' ? selected : null;
  }

  getPeopleCount() {
    return parseInt(this.quantityInput.value) || 1;
  }

  hasRequiredSelections() {
    if (this.hasIngresso && this.ingressoRequired && !this.getSelectedIngresso()) return false;

    if (this.hasNights && !this.form.querySelector('input[name="nights_type"]:checked')) return false;

    if (this.hasHotel && this.hotelRequired) {
      const hotelSelected = this.form.querySelector('input[name="hotel_type"]:checked');
      if (!hotelSelected || hotelSelected.value === 'no_hotel') return false;
    }

    if (this.hasVoo) {
      const totalFlights = this.calculateTotalFlights();
      if (this.vooRequired && totalFlights === 0) return false;
      if (totalFlights > 0 && totalFlights !== this.getPeopleCount()) return false;
    }

    return true;
  }

  findNextAvailableStep(currentIndex) {
    if (currentIndex < this.steps.length - 1) {
      return currentIndex + 1;
    }
    return -1;
  }

  goToNextStep() {
    let nextIndex = this.findNextAvailableStep(this.currentStepIndex);

    // Se estiver no step 3 (hotel) e "no_hotel" foi selecionado, pular o step 4 (configuração do quarto)
    if (this.currentStepIndex >= 0 && this.steps[this.currentStepIndex]) {
      const currentStepId = this.steps[this.currentStepIndex].dataset.step;

      if (currentStepId === '3' && this.hasHotel) {
        const selectedHotel = this.form.querySelector('input[name="hotel_type"]:checked');

        if (selectedHotel && selectedHotel.value === 'no_hotel') {
          // Pular o step 4 (configuração do quarto) e ir direto para o próximo step disponível
          const step4Index = Array.from(this.steps).findIndex(step => step.dataset.step === '4');

          if (step4Index >= 0) {
            // Marcar o step 4 como visitado para permitir navegação normal
            if (!this.visitedSteps.includes(step4Index)) {
              this.visitedSteps.push(step4Index);
            }
            this.steps[step4Index].classList.add('visited');

            // Se o próximo step seria o 4, pular para o próximo após o 4
            if (nextIndex === step4Index) {
              nextIndex = this.findNextAvailableStep(step4Index);
            }
          }
        }
      }
    }

    if (nextIndex > 0) {
      this.goToStep(nextIndex);

      if (!this.visitedSteps.includes(nextIndex)) {
        this.visitedSteps.push(nextIndex);
      }
    }
  }

  goToStep(stepIndex) {
    if (stepIndex >= 0 && stepIndex < this.steps.length) {
      this.steps[this.currentStepIndex].classList.remove('active');

      this.resetSelectionsAfter(stepIndex);

      this.currentStepIndex = stepIndex;

      this.steps[this.currentStepIndex].classList.add('active');
      this.steps[this.currentStepIndex].setAttribute('data-height', this.steps[this.currentStepIndex].scrollHeight);

      this.steps.forEach((step, index) => {
        if (index <= stepIndex) {
          step.classList.add('visited');
        } else {
          step.classList.remove('visited');
        }
      });

      this.steps[this.currentStepIndex].scrollIntoView({ behavior: 'smooth' });

      if (!this.visitedSteps.includes(stepIndex)) {
        this.visitedSteps.push(stepIndex);
      }

      if (this.steps[this.currentStepIndex].dataset.step === '4' && this.hasHotel && !this.hasNights) {
        const selectedHotel = this.form.querySelector('input[name="hotel_type"]:checked');
        if (selectedHotel) {
          const hotelName = selectedHotel.value;
          const hotelOptions = this.form.querySelectorAll('.hotel-option');

          if (hotelName === 'no_hotel') {
            hotelOptions.forEach(option => {
              option.style.display = 'none';
            });
          } else {
            hotelOptions.forEach(option => {
              option.style.display = (option.dataset.hotel === hotelName && this.isActiveHotelSource(option)) ? 'block' : 'none';
            });
          }
        }

        this.updateRoomConfirmButton();
      }

      if (stepIndex === 4 && this.hasHotel && this.hasNights) {
        const selectedHotel = this.form.querySelector('input[name="hotel_type"]:checked');
        const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');

        if (selectedHotel && nightsInput) {
          const hotelName = selectedHotel.value;
          const selectedNightsTitle = nightsInput.dataset.nightsDisplay || nightsInput.dataset.title.split(' / ')[0];
          const hotelOptions = this.form.querySelectorAll('.hotel-option');

          if (hotelName === 'no_hotel') {
            hotelOptions.forEach(option => {
              option.style.display = 'none';
            });
          } else {
            hotelOptions.forEach(option => {
              const variantData = option.querySelector('.hotel-variant-data');
              const nightsValue = variantData ? variantData.dataset.nights : null;
              const matchesHotel = option.dataset.hotel === hotelName;
              const matchesNights = !nightsValue || nightsValue === selectedNightsTitle;
              option.style.display = (matchesHotel && matchesNights && this.isActiveHotelSource(option)) ? 'block' : 'none';
            });
          }
        }
      }

      this.updatePriceDisplay();
      this.updateSummary();
    }
  }

  // Funções update - Update
  async updateSummary() {
    const quantity = parseInt(this.quantityInput.value) || 1;

    this.updateIngressoSummary(quantity);

    this.updateNightsSummary();

    this.updateHotelSummary();

    this.updateVooSummary();

    const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
    if (floatingResumo && floatingResumo.classList.contains('show')) {
      this.updateFloatingSummary();
    }

    this.updateFloatingButtons();
  }

  updateIngressoSummary(quantity) {
    if (!this.hasIngresso || !this.summaryIngresso) return;

    const ingressoInput = this.getSelectedIngresso();
    if (ingressoInput) {
      const title = ingressoInput.dataset.title || ingressoInput.closest('label').textContent.trim();
      this.summaryIngresso.style.display = 'block';
      this.summaryIngresso.querySelector('.selected-ingresso').textContent = title;
      this.summaryIngresso.querySelector('.ingresso-quantity').textContent = `Quantidade: ${quantity}`;
    } else {
      this.summaryIngresso.style.display = 'none';
    }
  }

  updateNightsSummary() {
    if (!this.hasNights || !this.summaryNights) return;

    const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
    if (nightsInput) {
      const title = nightsInput.dataset.title;

      this.summaryNights.style.display = 'block';
      this.summaryNights.querySelector('.selected-nights').textContent = title;
    } else {
      this.summaryNights.style.display = 'none';
    }
  }

  updateHotelSummary() {
    if (!this.hasHotel || !this.summaryHotel) return;

    const selectedHotels = [];
    let totalHotelQuantity = 0;
    let totalBeds = 0;
    let maxStars = 0;

    this.form.querySelectorAll('.hotel-option').forEach(option => {
      if (option.style.display !== 'none') {
        const quantityInput = option.querySelector('.hotel-quantity');
        const variantData = option.querySelector('.hotel-variant-data');
        const quantity = parseInt(quantityInput.value) || 0;

        if (quantity > 0) {
          const beds = parseInt(variantData.dataset.beds) || 1;
          const stars = parseInt(variantData.dataset.stars) || 0;

          if (stars > maxStars) {
            maxStars = stars;
          }

          selectedHotels.push({
            title: variantData.dataset.title,
            quantity: quantity,
            beds: beds,
            totalBeds: quantity * beds,
            stars: stars
          });
          totalHotelQuantity += quantity;
          totalBeds += quantity * beds;
        }
      }
    });

    if (selectedHotels.length > 0) {
      this.summaryHotel.style.display = 'block';

      let hotelText = '';
      selectedHotels.forEach(hotel => {
        hotelText += `${hotel.title} (x${hotel.quantity})<br>`;
      });

      this.summaryHotel.querySelector('.selected-hotel').innerHTML = hotelText;

      this.summaryHotel.querySelector('.hotel-quantity').textContent =
        `Total: ${totalHotelQuantity} quarto(s)`;

      const starsElement = this.summaryHotel.querySelector('.hotel-stars');
      if (starsElement) {
        starsElement.innerHTML = '';
        starsElement.style.display = 'none';
      }
    } else {
      this.summaryHotel.style.display = 'none';
    }
  }

  updateVooSummary() {
    if (!this.hasVoo || !this.summaryVoo || !this.quantityVooInputs) return;

    const selectedFlights = [];
    let totalFlightQuantity = 0;

    this.form.querySelectorAll('.voo-option').forEach(option => {
      if (option.style.display !== 'none') {
        const quantityInput = option.querySelector('.voo-quantity');
        const variantData = option.querySelector('.voo-variant-data');
        const quantity = parseInt(quantityInput.value) || 0;

        if (quantity > 0) {


          selectedFlights.push({
            title: variantData.dataset.title,
            quantity: quantity,
          });
          totalFlightQuantity += quantity;
        }
      }
    });

    if (selectedFlights.length > 0) {
      this.summaryVoo.style.display = 'block';

      let flightText = '';
      selectedFlights.forEach(flight => {
        flightText += `${flight.title} (x${flight.quantity})<br>`;
      });

      this.summaryVoo.querySelector('.selected-voo').innerHTML = flightText;

      this.summaryVoo.querySelector('.voo-quantity').textContent =
        `Total: ${totalFlightQuantity} passagem(ns)`;

    } else {
      this.summaryVoo.style.display = 'none';
    }
  }

  updatePriceDisplay() {
    let totalPrice = 0;

    totalPrice += this.calculateIngressoPrice();

    totalPrice += this.calculateNightsPrice();

    totalPrice += this.calculateHotelPrice();

    totalPrice += this.calculateVooPrice();

    if (totalPrice === 0 && this.initialProductPrice > 0) {
      totalPrice = this.initialProductPrice;
    }

    this.updatePriceElements(totalPrice);
  }

  updatePriceElements(totalPrice) {
    const pricePerPerson = totalPrice / 100;
    const installment = pricePerPerson / this.quantidadeParcelas;

    const totalPriceElement = this.form.querySelector('.total-price');
    const totalInstallmentsElement = this.form.querySelector('.total-installments');

    if (totalPriceElement) {
      totalPriceElement.textContent = this.formatCurrency(pricePerPerson);
    }

    if (totalInstallmentsElement) {
      totalInstallmentsElement.textContent = `ou ${this.quantidadeParcelas}x de ${this.formatCurrency(installment)}`;
    }

    const mainPriceDisplay = document.querySelector('.ec-product-main-infos-price h2');
    if (mainPriceDisplay) {
      mainPriceDisplay.textContent = `a partir de ${this.quantidadeParcelas}x de R$ ${installment.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }
  }

  updateCartDrawer(cartDrawer, result) {
    cartDrawer.renderContents(result);

    cartDrawer.classList.remove('is-empty');
    const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove('is-empty');
    }
  }

  updateMaxQuantities() {
    const maxQuantity = parseInt(this.quantityInput.value) || 1;

    this.updateVooMaxQuantity(maxQuantity);

    this.updateHotelMaxQuantities(maxQuantity);

    // Atualiza a disposição dos elementos voo-option baseado na nova quantidade
    this.setupVooSelection();

    this.updatePriceDisplay();
    this.updateSummary();
  }

  updateVooMaxQuantity(maxQuantity) {
    if (!this.hasVoo || !this.quantityVooInputs) return;

    const totalFlights = this.calculateTotalFlights();

    if (totalFlights > maxQuantity && totalFlights > 0) {

      let remainingFlights = totalFlights;

      for (const input of this.quantityVooInputs) {
        let currentValue = parseInt(input.value) || 0;

        while (currentValue > 0 && remainingFlights > maxQuantity) {
          currentValue--;
          remainingFlights--;
        }

        input.value = currentValue;
      }
    }
  }

  updateHotelMaxQuantities(maxQuantity) {
    if (!this.hasHotel || this.hotelQuantityInputs.length === 0) return;

    let totalBeds = this.calculateTotalBeds();

    if (totalBeds > maxQuantity) {
      const sortedInputs = this.getSortedHotelInputs();

      for (const input of sortedInputs) {
        const bedsPerRoom = parseInt(input.dataset.step) || 1;
        let currentValue = parseInt(input.value) || 0;

        // Only drop rooms that are no longer needed to fit every guest
        while (currentValue > 0 && totalBeds - bedsPerRoom >= maxQuantity) {
          currentValue--;
          totalBeds -= bedsPerRoom;
        }

        input.value = currentValue;
      }
    }
  }

  async updateIngressoAvailability() {
    if (!this.hasIngresso) return;

    const ingressoInputs = this.form.querySelectorAll('input[name="variant_ingresso"]');
    const userQuantity = parseInt(this.quantityInput.value) || 1;

    let anyAvailable = false;

    for (const input of ingressoInputs) {
      if (input.value === 'no_ingresso') continue;

      const variantId = parseInt(input.value);
      let inventory;
      if (input.dataset.inventory && input.dataset.available) {
        inventory = {
          id: variantId,
          available: input.dataset.available === 'true',
          inventory_quantity: parseInt(input.dataset.inventory) || 0
        };
      } else {
        inventory = await this.checkVariantInventory(variantId);
      }

      const label = input.closest('label');

      if (!inventory.available || inventory.inventory_quantity < userQuantity) {
        input.dataset.soldOut = 'true';

        if (label) {
          label.classList.add('sold-out');
          const priceSpan = label.querySelector('.bundle-increase-value');
          if (priceSpan) {
            priceSpan.textContent = 'ESGOTADO';
          }
        }
      } else {
        input.dataset.soldOut = 'false';
        anyAvailable = true;

        if (label) {
          label.classList.remove('sold-out');
          const priceSpan = label.querySelector('.bundle-increase-value');
          const price = input.dataset.price;
          if (priceSpan && price && !priceSpan.textContent.includes('+')) {
            priceSpan.textContent = `${this.formatCurrency(price / 100)}`;
          }
        }
      }
    }

    const stepElement = this.form.querySelector('.bundle-step[data-step="2"]');
    const messageElement = stepElement?.querySelector('.sold-out-message');

    if (!anyAvailable && messageElement) {
      messageElement.style.display = 'block';
    } else if (messageElement) {
      messageElement.style.display = 'none';
    }

    this.updateIngressoConfirmButton();

    this.setMaxQuantityLimit();
  }

  async updateHotelAvailability() {
    if (!this.hasHotel) return;

    const hotelOptions = this.form.querySelectorAll('.hotel-option');

    for (const option of hotelOptions) {
      if (option.style.display === 'none') continue;

      const variantData = option.querySelector('.hotel-variant-data');
      const variantId = parseInt(variantData.dataset.id);

      let inventory;
      if (variantData.dataset.inventory && variantData.dataset.available) {
        inventory = {
          id: variantId,
          available: variantData.dataset.available === 'true',
          inventory_quantity: parseInt(variantData.dataset.inventory) || 0
        };
      } else {
        inventory = await this.checkVariantInventory(variantId);
      }

      const quantityInput = option.querySelector('.hotel-quantity');
      const decreaseBtn = option.querySelector('.decrease-qty-hotel');
      const increaseBtn = option.querySelector('.increase-qty-hotel');

      if (!inventory.available || inventory.inventory_quantity === 0) {
        quantityInput.disabled = true;
        decreaseBtn.disabled = true;
        increaseBtn.disabled = true;

        option.classList.add('sold-out');

        const priceElement = option.querySelector('p');
        if (priceElement && !priceElement.textContent.includes('ESGOTADO')) {
          priceElement.innerHTML = `${priceElement.textContent.split(':')[0]}: <span class="bundle-increase-value">ESGOTADO</span>`;
        }
      } else {
        quantityInput.disabled = false;
        decreaseBtn.disabled = false;
        increaseBtn.disabled = false;

        option.classList.remove('sold-out');

        const maxRooms = inventory.inventory_quantity;
        quantityInput.setAttribute('max', maxRooms);

        if (parseInt(quantityInput.value) > maxRooms) {
          quantityInput.value = maxRooms;
          this.updatePriceDisplay();
          this.updateSummary();
        }

        const priceElement = option.querySelector('p');
        if (priceElement && priceElement.textContent.includes('ESGOTADO')) {
          const price = variantData.dataset.price;
          const bedQuantity = parseInt(variantData.dataset.beds) || 1;
          const pricePerPerson = price / bedQuantity;
          priceElement.innerHTML = `${priceElement.textContent.split(':')[0]}: <span class="bundle-increase-value">+${this.formatCurrency(pricePerPerson / 100)}(p/pessoa)</span>`;
        }
      }
    }
  }

  async updateVooAvailability() {
    if (!this.hasVoo || !this.quantityVooInputs) return;

    const vooOptions = this.form.querySelectorAll('.voo-option');

    for (const option of vooOptions) {
      if (option.style.display === 'none') continue;

      const variantData = option.querySelector('.voo-variant-data');
      const variantId = parseInt(variantData.dataset.id);

      let inventory;
      if (variantData.dataset.inventory && variantData.dataset.available) {
        inventory = {
          id: variantId,
          available: variantData.dataset.available === 'true',
          inventory_quantity: parseInt(variantData.dataset.inventory) || 0
        };
      } else {
        inventory = await this.checkVariantInventory(variantId);
      }

      const quantityInput = option.querySelector('.voo-quantity');
      const decreaseBtn = option.querySelector('.decrease-qty-voo');
      const increaseBtn = option.querySelector('.increase-qty-voo');

      if (!inventory.available || inventory.inventory_quantity === 0) {
        quantityInput.disabled = true;
        decreaseBtn.disabled = true;
        increaseBtn.disabled = true;

        option.classList.add('sold-out');

        const priceElement = option.querySelector('p');
        if (priceElement && !priceElement.textContent.includes('ESGOTADO')) {
          priceElement.innerHTML = `${priceElement.textContent.split(':')[0]}: <span class="bundle-increase-value">ESGOTADO</span>`;
        }
      } else {
        quantityInput.disabled = false;
        decreaseBtn.disabled = false;
        increaseBtn.disabled = false;

        option.classList.remove('sold-out');

        const maxFlights = inventory.inventory_quantity;
        quantityInput.setAttribute('max', maxFlights);

        if (parseInt(quantityInput.value) > maxFlights) {
          quantityInput.value = maxFlights;
          this.updatePriceDisplay();
          this.updateSummary();
        }

        const priceElement = option.querySelector('p');
        if (priceElement && priceElement.textContent.includes('ESGOTADO')) {
          const price = variantData.dataset.price;
          priceElement.innerHTML = `${priceElement.textContent.split(':')[0]}: <span class="bundle-increase-value">+${this.formatCurrency(price / 100)}(p/pessoa)</span>`;
        }
      }
    }
  }

  updateTicketPreview(selectedInput) {
    if (!this.hasIngresso) return;

    const placeholder = this.form.querySelector('.ec-ticket-preview-placeholder');
    const allPreviews = this.form.querySelectorAll('.ec-ticket-image-preview');
    const previewContainer = this.form.querySelector('.ec-ticket-preview');

    allPreviews.forEach(preview => {
      preview.style.display = 'none';
      const soldOutBadge = preview.querySelector('.ec-ticket-sold-out-badge');
      if (soldOutBadge) {
        soldOutBadge.style.display = 'none';
      }
    });

    if (selectedInput && selectedInput.checked && selectedInput.value !== 'no_ingresso') {
      const variantId = selectedInput.value;
      const targetPreview = this.form.querySelector(`.ec-ticket-image-preview[data-variant="${variantId}"]`);

      if (targetPreview) {
        previewContainer.style.display = 'block';
        placeholder.style.display = 'none';
        targetPreview.style.display = 'block';

        const isSoldOut = selectedInput.dataset.soldOut === 'true';
        const soldOutBadge = targetPreview.querySelector('.ec-ticket-sold-out-badge');

        if (soldOutBadge && isSoldOut) {
          soldOutBadge.style.display = 'block';
        }
      } else {
        previewContainer.style.display = 'none';
      }
    } else {
      previewContainer.style.display = 'block';
      placeholder.style.display = 'block';
    }
  }

  updateNightsPreview(input) {
    const variantId = input.value;
    const nightsStep = this.form.querySelector('.bundle-nights');
    if (!nightsStep) return;

    const allPreviews = nightsStep.querySelectorAll('.ec-ticket-image-preview');
    const placeholder = nightsStep.querySelector('.ec-ticket-preview-placeholder');

    allPreviews.forEach(preview => {
      if (preview.dataset.variant === variantId) {
        preview.style.display = 'block';
        if (placeholder) placeholder.style.display = 'none';

        const soldOut = input.dataset.soldOut === 'true';
        const badge = preview.querySelector('.ec-ticket-sold-out-badge');
        if (badge) {
          badge.style.display = soldOut ? 'block' : 'none';
        }
      } else {
        preview.style.display = 'none';
      }
    });
  }

  filterHotelVariantsByNights(selectedNightsTitle) {
    const hotelOptions = this.form.querySelectorAll('.hotel-option');

    hotelOptions.forEach(option => {
      const variantData = option.querySelector('.hotel-variant-data');
      const nightsValue = variantData ? variantData.dataset.nights : null;

      if (nightsValue === selectedNightsTitle && this.isActiveHotelSource(option)) {
        option.style.display = 'flex';
      } else {
        option.style.display = 'none';
        // Resetar quantidade se estava selecionado
        const qtyInput = option.querySelector('.hotel-quantity');
        if (qtyInput) qtyInput.value = 0;
      }
    });

    this.updatePriceDisplay();
    this.updateSummary();
  }

  async updateNightsAvailability() {
    if (!this.hasNights) return;

    const nightsInputs = this.form.querySelectorAll('input[name="nights_type"]');
    const userQuantity = parseInt(this.quantityInput.value) || 1;

    let anyAvailable = false;

    for (const input of nightsInputs) {
      const variantId = parseInt(input.value);
      let inventory;
      if (input.dataset.inventory && input.dataset.available) {
        inventory = {
          id: variantId,
          available: input.dataset.available === 'true',
          inventory_quantity: parseInt(input.dataset.inventory) || 0
        };
      } else {
        inventory = await this.checkVariantInventory(variantId);
      }

      const label = input.closest('label');

      if (!inventory.available || inventory.inventory_quantity < userQuantity) {
        input.dataset.soldOut = 'true';

        if (label) {
          label.classList.add('sold-out');
          const priceSpan = label.querySelector('.bundle-increase-value');
          if (priceSpan) {
            priceSpan.textContent = 'ESGOTADO';
          }
        }
      } else {
        input.dataset.soldOut = 'false';
        anyAvailable = true;

        if (label) {
          label.classList.remove('sold-out');
          const priceSpan = label.querySelector('.bundle-increase-value');
          const price = input.dataset.price;
          if (priceSpan && price && !priceSpan.textContent.includes('+')) {
            priceSpan.textContent = `${this.formatCurrency(price / 100)}`;
          }
        }
      }
    }

    const stepElement = this.form.querySelector('.bundle-step[data-step="3"]');
    const messageElement = stepElement?.querySelector('.sold-out-message');

    if (!anyAvailable && messageElement) {
      messageElement.style.display = 'block';
    } else if (messageElement) {
      messageElement.style.display = 'none';
    }

    this.updateNightsConfirmButton();
  }

  updateIngressoConfirmButton() {
    if (!this.hasIngresso) return;

    const ingressoStep = this.form.querySelector('.bundle-step[data-step="2"]');
    if (!ingressoStep) return;

    const confirmButton = ingressoStep.querySelector('.confirm-step');
    if (!confirmButton) return;

    const selectedInput = this.form.querySelector('input[name="variant_ingresso"]:checked');

    if (selectedInput) {
      const isSoldOut = selectedInput.dataset.soldOut === 'true';
      const isNoIngresso = selectedInput.value === 'no_ingresso';

      if (isNoIngresso) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      } else if (isSoldOut) {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Categoria esgotada';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      } else {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar categoria';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      }
    } else {
      confirmButton.disabled = true;
      confirmButton.textContent = 'Selecione uma categoria';
      confirmButton.style.opacity = '0.5';
      confirmButton.style.cursor = 'not-allowed';
    }
  }

  updateNightsConfirmButton() {
    if (!this.hasNights) return;

    const nightsStep = this.form.querySelector('.bundle-step[data-step="3"]');
    if (!nightsStep) return;

    const confirmButton = nightsStep.querySelector('.confirm-step');
    if (!confirmButton) return;

    const selectedInput = this.form.querySelector('input[name="nights_type"]:checked');

    if (selectedInput) {
      const isSoldOut = selectedInput.dataset.soldOut === 'true';

      if (isSoldOut) {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Quantidade de noites esgotada';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      } else {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar noites';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      }
    } else {
      confirmButton.disabled = true;
      confirmButton.textContent = 'Selecione a quantidade de noites';
      confirmButton.style.opacity = '0.5';
      confirmButton.style.cursor = 'not-allowed';
    }
  }

  updateHotelPreview(selectedInput) {
    if (!this.hasHotel) return;

    const placeholder = this.form.querySelector('.ec-hotel-preview-placeholder');
    const allPreviews = this.form.querySelectorAll('.ec-hotel-image-preview');
    const previewContainer = this.form.querySelector('.ec-hotel-preview');

    allPreviews.forEach(preview => {
      preview.style.display = 'none';
      const soldOutBadge = preview.querySelector('.ec-hotel-sold-out-badge');
      if (soldOutBadge) {
        soldOutBadge.style.display = 'none';
      }
    });

    if (selectedInput && selectedInput.checked) {
      const variantId = selectedInput.getAttribute('data-variant');
      const targetPreview = this.form.querySelector(`.ec-hotel-image-preview[data-variant="${variantId}"]`);

      if (targetPreview) {
        previewContainer.style.display = 'block';
        placeholder.style.display = 'none';
        targetPreview.style.display = 'block';

        const isSoldOut = selectedInput.dataset.soldOut === 'true';
        const soldOutBadge = targetPreview.querySelector('.ec-hotel-sold-out-badge');

        if (soldOutBadge && isSoldOut) {
          soldOutBadge.style.display = 'block';
        }
      } else {
        previewContainer.style.display = 'none';
      }
    } else {
      previewContainer.style.display = 'block';
      placeholder.style.display = 'block';
    }
  }

  updateVooConfirmButton() {
    if (!this.hasVoo) return;

    const vooStep = this.form.querySelector('.bundle-step[data-step="5"]');
    if (!vooStep) return;

    const confirmButton = vooStep.querySelector('.confirm-step');
    if (!confirmButton) return;

    const skipVooOption = this.form.querySelector('input[name="voo_type"]:checked');
    const isSkipped = skipVooOption && skipVooOption.value === 'no_voo';
    const totalFlights = this.calculateTotalFlights();
    const missingFlights = this.getPeopleCount() - totalFlights;

    if (isSkipped || missingFlights === 0) {
      confirmButton.disabled = false;
      confirmButton.textContent = 'Avançar para o resumo';
      confirmButton.style.opacity = '1';
      confirmButton.style.cursor = 'pointer';
    } else {
      confirmButton.disabled = true;
      confirmButton.textContent = totalFlights === 0
        ? 'Selecione uma opção'
        : `${missingFlights === 1 ? 'Falta' : 'Faltam'} ${missingFlights} ${missingFlights === 1 ? 'passagem' : 'passagens'}`;
      confirmButton.style.opacity = '0.5';
      confirmButton.style.cursor = 'not-allowed';
    }
  }

  updateFloatingSummary() {
    if (!document.querySelector('.ec-bundle-product-floating-resumo')) return;

    const quantity = parseInt(this.quantityInput.value) || 1;

    this.updateIngressoFloatingSummary(quantity);
    this.updateNightsFloatingSummary();
    this.updateHotelFloatingSummary();
    this.updateVooFloatingSummary();
    this.updateTotalFloatingSummary();
    this.updateFloatingButtons();
  }

  updateIngressoFloatingSummary(quantity) {
    if (!this.hasIngresso) return;

    const summaryIngressoElements = document.querySelectorAll('.summary-ingresso-floating');
    if (!summaryIngressoElements.length) return;

    const ingressoInput = this.getSelectedIngresso();
    if (ingressoInput) {
      const title = ingressoInput.dataset.title || ingressoInput.closest('label').textContent.trim();

      summaryIngressoElements.forEach(el => el.style.display = 'flex');

      const quantityElement = document.querySelector('.ingresso-quantity-floating');
      if (quantityElement) {
        quantityElement.textContent = quantity;
      }

      const selectedElement = document.querySelector('.selected-ingresso-floating');
      if (selectedElement) {
        selectedElement.textContent = title;
      }
    } else {
      summaryIngressoElements.forEach(el => el.style.display = 'none');
    }
  }

  updateNightsFloatingSummary() {
    if (!this.hasNights) return;

    const summaryNightsElements = document.querySelectorAll('.summary-nights-floating');
    if (!summaryNightsElements.length) return;

    const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
    if (nightsInput) {
      const title = nightsInput.dataset.title;

      summaryNightsElements.forEach(el => el.style.display = 'flex');

      const selectedElement = document.querySelector('.selected-nights-floating');
      if (selectedElement) {
        selectedElement.textContent = title;
      }
    } else {
      summaryNightsElements.forEach(el => el.style.display = 'none');
    }
  }

  updateHotelFloatingSummary() {
    if (!this.hasHotel) return;

    const summaryHotelElements = document.querySelectorAll('.summary-hotel-floating');
    if (!summaryHotelElements.length) return;

    const selectedHotels = [];
    let totalHotelQuantity = 0;
    let totalBeds = 0;
    let maxStars = 0;

    this.form.querySelectorAll('.hotel-option').forEach(option => {
      if (option.style.display !== 'none') {
        const quantityInput = option.querySelector('.hotel-quantity');
        const variantData = option.querySelector('.hotel-variant-data');
        const quantity = parseInt(quantityInput.value) || 0;

        if (quantity > 0) {
          const beds = parseInt(variantData.dataset.beds) || 1;
          const stars = parseInt(variantData.dataset.stars) || 0;

          if (stars > maxStars) {
            maxStars = stars;
          }

          selectedHotels.push({
            title: variantData.dataset.title,
            quantity: quantity,
            beds: beds,
            totalBeds: quantity * beds,
            stars: stars
          });
          totalHotelQuantity += quantity;
          totalBeds += quantity * beds;
        }
      }
    });

    if (selectedHotels.length > 0) {
      summaryHotelElements.forEach(el => el.style.display = 'flex');

      const selectedHotelElement = document.querySelector('.selected-hotel-floating');
      if (selectedHotelElement && selectedHotels.length > 0) {
        let hotelText = '';
        selectedHotels.forEach(hotel => {
          hotelText += `${hotel.title} (x${hotel.quantity})`;
          if (selectedHotels.indexOf(hotel) < selectedHotels.length - 1) {
            hotelText += '<br>';
          }
        });
        selectedHotelElement.innerHTML = hotelText;
      }

      const hotelQuantityElement = document.querySelector('.hotel-quantity-floating');
      if (hotelQuantityElement) {
        hotelQuantityElement.textContent = `Total: ${totalHotelQuantity} quarto(s)`;
      }
    } else {
      summaryHotelElements.forEach(el => el.style.display = 'none');
    }
  }

  updateVooFloatingSummary() {
    if (!this.hasVoo || !this.quantityVooInputs) return;

    const summaryVooElements = document.querySelectorAll('.summary-voo-floating');
    if (!summaryVooElements.length) return;

    const quantityVoo = this.calculateTotalFlights();

    if (quantityVoo > 0) {
      summaryVooElements.forEach(el => el.style.display = 'flex');

      const vooQuantityElement = document.querySelector('.voo-quantity-floating');
      if (vooQuantityElement) {
        vooQuantityElement.textContent = `Quantidade: ${quantityVoo}`;
      }
    } else {
      summaryVooElements.forEach(el => el.style.display = 'none');
    }
  }

  updateTotalFloatingSummary() {
    let totalPrice = 0;

    totalPrice += this.calculateIngressoPrice();
    totalPrice += this.calculateNightsPrice();
    totalPrice += this.calculateHotelPrice();
    totalPrice += this.calculateVooPrice();

    if (totalPrice === 0 && this.initialProductPrice > 0) {
      totalPrice = this.initialProductPrice;
    }

    const pricePerPerson = totalPrice / 100;
    const installment = pricePerPerson / this.quantidadeParcelas;

    const subtotalElement = document.querySelector('.floating-subtotal-value');
    const totalElement = document.querySelector('.floating-total-value');

    if (subtotalElement) {
      subtotalElement.textContent = this.formatCurrency(pricePerPerson);
    }

    if (totalElement) {
      totalElement.textContent = `ou ${this.quantidadeParcelas}x de ${this.formatCurrency(installment)}`;
    }
  }

  updateFloatingButtons() {
    const addToCartFloating = document.querySelector('#add-to-cart-bundle-floating');

    if (!addToCartFloating) return;

    const isOnSummaryStep = this.currentStepIndex !== undefined &&
      this.steps &&
      this.steps[this.currentStepIndex] &&
      this.steps[this.currentStepIndex].dataset.step === '6';

    if (!isOnSummaryStep) {
      addToCartFloating.disabled = true;
      return;
    }

    const hasItems = this.collectSelectedItems().length > 0;
    const shouldEnable = hasItems && this.hasRequiredSelections();

    addToCartFloating.disabled = !shouldEnable;
  }

  // Funções handle - Handle
  handleIncrease() {
    const current = parseInt(this.quantityInput.value) || 1;
    const maxAllowed = parseInt(this.quantityInput.getAttribute('max')) || 999;

    if (current < maxAllowed) {
      this.quantityInput.value = current + 1;
      this.updateMaxQuantities();
      this.checkAllInventory();
    } else {
      console.log(`Não é possível adicionar mais ingressos. Limite máximo: ${maxAllowed}`);
    }
  }

  handleDecrease() {
    const current = parseInt(this.quantityInput.value) || 1;
    if (current > 1) {
      this.quantityInput.value = current - 1;
      this.updateMaxQuantities();

      this.checkAllInventory();
    }
  }

  handleIncreaseVoo(input) {
    if (!this.hasVoo || !this.quantityVooInputs) return;

    let totalFlights = this.calculateTotalFlights();

    const current = parseInt(input.value) || 0;
    const maxQuantity = parseInt(this.quantityInput.value) || 1;
    const maxVoos = parseInt(input.getAttribute('max')) || maxQuantity;

    if (current >= maxVoos) {
      console.log(`Não é possível adicionar mais quartos. Limite de estoque: ${maxVoos}.`);
      return;
    }

    if (totalFlights < maxQuantity) {
      const skipVooOption = this.form.querySelector('input[name="voo_type"]:checked');
      if (skipVooOption && skipVooOption.value === 'no_voo') {
        skipVooOption.checked = false;
      }

      input.value = current + 1;
      this.updatePriceDisplay();
      this.updateSummary();
      this.updateVooConfirmButton();
    } else {
      this.showQuantityLimitTooltip(input, this.buildQuantityLimitMessage(maxQuantity, 'passagem', 'passagens'));
    }
  }

  handleDecreaseVoo(input) {
    if (!this.hasVoo || !this.quantityVooInputs) return;

    const current = parseInt(input.value) || 0;
    if (current > 0) {
      input.value = current - 1;
      this.updatePriceDisplay();
      this.updateSummary();
      this.updateVooConfirmButton();
    }
  }

  handleIncreaseHotel(input) {
    if (!this.hasHotel) return;

    const current = parseInt(input.value) || 0;
    const maxQuantity = parseInt(this.quantityInput.value) || 1;

    const maxRooms = parseInt(input.getAttribute('max')) || 0;
    if (current >= maxRooms) {
      console.log(`Não é possível adicionar mais quartos. Limite de estoque: ${maxRooms}.`);
      return;
    }

    const bedsPerRoom = parseInt(input.dataset.step) || 1;
    const totalBeds = this.calculateTotalBeds();

    if (totalBeds + bedsPerRoom <= maxQuantity) {
      input.value = current + 1;
      this.updatePriceDisplay();
      this.updateSummary();
      this.updateRoomConfirmButton();
    } else {
      this.showQuantityLimitTooltip(input, this.buildQuantityLimitMessage(maxQuantity, 'cama', 'camas'));
    }
  }

  buildQuantityLimitMessage(maxQuantity, singularLabel, pluralLabel) {
    const itemLabel = maxQuantity === 1 ? singularLabel : pluralLabel;
    return `Máximo de ${maxQuantity} ${itemLabel}: 1 por ingresso comprado. <strong>Adicione mais pacotes na etapa 1.</strong>`;
  }

  showQuantityLimitTooltip(input, message) {
    const anchor = input.closest('.quantity-selector');
    if (!anchor) return;

    this.hideQuantityLimitTooltip();

    const tooltip = document.createElement('div');
    tooltip.className = 'quantity-limit-tooltip';
    tooltip.setAttribute('role', 'alert');
    tooltip.innerHTML = message;
    anchor.after(tooltip);

    this.quantityLimitTooltip = tooltip;
  }

  hideQuantityLimitTooltip() {
    this.quantityLimitTooltip?.remove();
    this.quantityLimitTooltip = null;
  }

  setupQuantityLimitDismiss() {
    this.form.addEventListener('click', (event) => {
      if (event.target.closest('.quantity-selector')) this.hideQuantityLimitTooltip();
    }, true);
  }

  handleDecreaseHotel(input) {
    if (!this.hasHotel) return;

    const current = parseInt(input.value) || 0;
    if (current > 0) {
      input.value = current - 1;
      this.updatePriceDisplay();
      this.updateSummary();
      this.updateRoomConfirmButton();
    }
  }

  // Funções calculate - Calculate
  calculateIngressoPrice() {
    if (!this.hasIngresso) return 0;

    const quantity = parseInt(this.quantityInput.value) || 1;
    const ingressoInput = this.getSelectedIngresso();

    if (ingressoInput) {
      const ingressoPrice = parseInt(ingressoInput.dataset.price) * quantity;

      if (this.summaryIngresso && this.summaryIngresso.style.display !== 'none') {
        this.summaryIngresso.querySelector('.ingresso-price').textContent =
          `Preço: ${this.formatCurrency(ingressoPrice / 100)}`;
      }

      return ingressoPrice;
    }

    return 0;
  }

  calculateNightsPrice() {
    if (!this.hasNights) return 0;

    const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
    if (!nightsInput) return 0;

    const price = parseInt(nightsInput.dataset.price) || 0;
    return price;
  }

  calculateHotelPrice() {
    if (!this.hasHotel) return 0;

    let totalHotelPrice = 0;

    this.form.querySelectorAll('.hotel-option').forEach(option => {
      if (option.style.display !== 'none') {
        const quantityInput = option.querySelector('.hotel-quantity');
        const variantData = option.querySelector('.hotel-variant-data');
        const quantity = parseInt(quantityInput.value) || 0;

        if (quantity > 0) {
          const price = parseInt(variantData.dataset.price) * quantity;
          totalHotelPrice += price;
        }
      }
    });

    if (this.summaryHotel && this.summaryHotel.style.display !== 'none') {
      this.summaryHotel.querySelector('.hotel-price').textContent =
        `Preço: ${this.formatCurrency(totalHotelPrice / 100)}`;
    }

    return totalHotelPrice;
  }

  calculateVooPrice() {
    if (!this.hasVoo || !this.quantityVooInputs) return 0;

    let totalFlightPrice = 0;

    this.form.querySelectorAll('.voo-option').forEach(option => {
      if (option.style.display !== 'none') {
        const quantityInput = option.querySelector('.voo-quantity');
        const variantData = option.querySelector('.voo-variant-data');
        const quantity = parseInt(quantityInput.value) || 0;

        if (quantity > 0) {
          const price = parseInt(variantData.dataset.price) * quantity;
          totalFlightPrice += price;
        }
      }
    });

    if (totalFlightPrice > 0) {
      if (this.summaryVoo && this.summaryVoo.style.display !== 'none') {
        this.summaryVoo.querySelector('.voo-price').textContent =
          `Preço: ${this.formatCurrency(totalFlightPrice / 100)}`;
      }

      return totalFlightPrice;
    }

    return 0;
  }

  calculateTotalBeds() {
    if (!this.hasHotel) return 0;

    let totalBeds = 0;
    this.hotelQuantityInputs.forEach(input => {
      const option = input.closest('.hotel-option');
      if (option && !this.isActiveHotelSource(option)) return;
      const beds = parseInt(input.dataset.step) || 1;
      totalBeds += (parseInt(input.value) || 0) * beds;
    });
    return totalBeds;
  }

  calculateTotalFlights() {
    if (!this.hasVoo) return 0;

    let totalFlights = 0;
    this.quantityVooInputs.forEach(input => {
      totalFlights += (parseInt(input.value) || 0);
    });
    return totalFlights;
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  reinitializeCheckoutButton() {
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    if (!checkoutButton) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const hasItems = cart.items.length > 0;
        checkoutButton.disabled = !hasItems;
        checkoutButton.textContent = 'Finalizar a compra';
        checkoutButton.style.opacity = hasItems ? '1' : '0.6';
        checkoutButton.style.cursor = hasItems ? 'pointer' : 'not-allowed';
      })
      .catch(() => {
        checkoutButton.disabled = false;
        checkoutButton.textContent = 'Finalizar a compra';
        checkoutButton.style.opacity = '1';
        checkoutButton.style.cursor = 'pointer';
      });
  }

  hasUnavailableItems() {
    const ingressoInput = this.getSelectedIngresso();
    if (this.hasIngresso && ingressoInput && ingressoInput.disabled) {
      alert('Um ou mais ingressos selecionados estão esgotados. Por favor, revise sua seleção.');
      return true;
    }

    const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
    if (this.hasNights && nightsInput && nightsInput.dataset.soldOut === 'true') {
      alert('A quantidade de noites selecionada está esgotada. Por favor, revise sua seleção.');
      return true;
    }

    if (this.hasHotel) {
      const hotelUnavailable = [...this.form.querySelectorAll('.hotel-option')]
        .filter(option => option.style.display !== 'none')
        .some(option => {
          const quantityInput = option.querySelector('.hotel-quantity');
          const quantity = parseInt(quantityInput.value) || 0;
          return quantity > 0 && (quantityInput.disabled || option.classList.contains('sold-out'));
        });

      if (hotelUnavailable) {
        alert('Um ou mais quartos selecionados estão esgotados. Por favor, revise sua seleção.');
        return true;
      }
    }

    if (this.hasVoo) {
      const vooUnavailable = [...this.form.querySelectorAll('.voo-option')]
        .filter(option => option.style.display !== 'none')
        .some(option => {
          const quantityInput = option.querySelector('.voo-quantity');
          const quantity = parseInt(quantityInput.value) || 0;
          return quantity > 0 && (quantityInput.disabled || option.classList.contains('sold-out'));
        });

      if (vooUnavailable) {
        alert('As passagens aéreas estão esgotadas. Por favor, revise sua seleção.');
        return true;
      }
    }

    return false;
  }

  async addMultipleItems(items, cartDrawer) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const result = await response.json();

    if (!response.ok) {
      const message = result.description || 'Erro desconhecido';
      alert(`Erro ao adicionar ao carrinho: ${message}`);
      return null;
    }

    await window.saveAsb26BundleDetailsToCartAttributes(this, this.productId);

    if (cartDrawer) {
      const sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);
      const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sectionsToRender.join(',')}`);
      const updatedSections = await sectionsResponse.json();

      return { ...result, sections: updatedSections };
    }

    return result;
  }

  dispatchCartUpdate() {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { source: 'bundle-form' }
    }));
  }

  collectSelectedItems() {
    const quantity = parseInt(this.quantityInput.value) || 1;
    const selectedItems = [];
    const bundleId = Date.now();

    const bundleProperty = { '_bundleId': bundleId };

    if (this.productId) {
      bundleProperty['_productId'] = this.productId;
    }

    if (this.hasIngresso) {
      const ingressoInput = this.getSelectedIngresso();
      if (ingressoInput) {
        selectedItems.push({
          id: parseInt(ingressoInput.value),
          quantity: quantity,
          properties: { ...bundleProperty, '_itemType': 'ingresso' }
        });
      }
    }

    if (this.hasNights) {
      const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
      if (nightsInput) {
        selectedItems.push({
          id: parseInt(nightsInput.value),
          quantity: 1,
          properties: { ...bundleProperty, '_itemType': 'noites' }
        });
      }
    }

    if (this.hasHotel) {
      this.form.querySelectorAll('.hotel-option').forEach(option => {
        if (option.style.display !== 'none' && this.isActiveHotelSource(option)) {
          const quantityInput = option.querySelector('.hotel-quantity');
          const variantData = option.querySelector('.hotel-variant-data');
          const quantity = parseInt(quantityInput.value) || 0;

          if (quantity > 0) {
            selectedItems.push({
              id: parseInt(variantData.dataset.id),
              quantity: quantity,
              properties: { ...bundleProperty, '_itemType': 'hotel' }
            });
          }
        }
      });
    }

    if (this.hasVoo) {
      this.form.querySelectorAll('.voo-option').forEach(option => {
        if (option.style.display !== 'none') {
          const quantityInput = option.querySelector('.voo-quantity');
          const variantData = option.querySelector('.voo-variant-data');
          const quantity = parseInt(quantityInput.value) || 0;

          if (quantity > 0) {
            selectedItems.push({
              id: parseInt(variantData.dataset.id),
              quantity: quantity,
              properties: { ...bundleProperty, '_itemType': 'voo' }
            });
          }
        }
      });
    }

    return selectedItems;
  }

  getSortedHotelInputs() {
    return Array.from(this.hotelQuantityInputs)
      .filter(input => {
        const option = input.closest('.hotel-option');
        return parseInt(input.value) > 0 && this.isActiveHotelSource(option);
      })
      .sort((a, b) => {
        const aVisible = a.closest('.hotel-option').style.display !== 'none';
        const bVisible = b.closest('.hotel-option').style.display !== 'none';

        if (aVisible !== bVisible) return aVisible ? 1 : -1;
        return 0;
      });
  }

  resetSelectionsAfter(stepIndex) {
    for (let i = 0; i < this.steps.length; i++) {
      if (i > stepIndex && parseInt(this.steps[i].dataset.step) > 1) {
        const step = this.steps[i];
        const stepNumber = parseInt(step.dataset.step);

        if (stepNumber === 2 && this.hasIngresso) {
          const ingressoInputs = step.querySelectorAll('input[name="variant_ingresso"]');
          ingressoInputs.forEach(input => {
            input.checked = false;
          });

          if (this.summaryIngresso) {
            this.summaryIngresso.style.display = 'none';
          }
        }

        if (stepNumber === 3 && this.hasNights) {
          const nightsInputs = step.querySelectorAll('input[name="nights_type"]');
          nightsInputs.forEach(input => {
            input.checked = false;
          });

          if (this.summaryNights) {
            this.summaryNights.style.display = 'none';
          }

          // Resetar filtro de hotéis
          const hotelOptions = this.form.querySelectorAll('.hotel-option');
          hotelOptions.forEach(option => {
            option.style.display = 'none';
            const qtyInput = option.querySelector('.hotel-quantity');
            if (qtyInput) qtyInput.value = 0;
          });
        }

        if (stepNumber === 3 && this.hasHotel && !this.hasNights) {
          const hotelTypeInputs = step.querySelectorAll('input[name="hotel_type"]');
          hotelTypeInputs.forEach(input => {
            input.checked = false;
          });

          if (this.summaryHotel) {
            this.summaryHotel.style.display = 'none';
          }
        }

        if (stepNumber === 4 && this.hasHotel) {
          // Se tem noites, step 4 é hotel, se não tem, step 4 é configuração de quarto
          if (this.hasNights) {
            const hotelTypeInputs = step.querySelectorAll('input[name="hotel_type"]');
            hotelTypeInputs.forEach(input => {
              input.checked = false;
            });

            if (this.summaryHotel) {
              this.summaryHotel.style.display = 'none';
            }
          } else {
            const hotelOptions = step.querySelectorAll('.hotel-option');
            hotelOptions.forEach(option => {
              const quantityInput = option.querySelector('.hotel-quantity');
              if (quantityInput) {
                quantityInput.value = 0;
              }
            });

            if (this.summaryHotel) {
              this.summaryHotel.style.display = 'none';
            }
          }
        }

        if (stepNumber === 5 && this.hasVoo) {
          const vooOptions = step.querySelectorAll('.voo-option');
          vooOptions.forEach(option => {
            const quantityInput = option.querySelector('.voo-quantity');
            if (quantityInput) {
              quantityInput.value = 0;
            }
          });

          if (this.summaryVoo) {
            this.summaryVoo.style.display = 'none';
          }
        }
      }
    }

    this.updatePriceDisplay();
    this.updateSummary();
    this.updateFloatingSummary();
  }

  // Funções check - Check
  checkStepCompletion() {
    const currentStep = this.steps[this.currentStepIndex];
    if (!currentStep) return;

    const stepId = currentStep.dataset.step;

    if (stepId === '3' && this.hasHotel) {
      if (!this.hotelRequired) return;

      const hotelSelected = this.form.querySelector('input[name="hotel_type"]:checked');
      if (hotelSelected) this.goToNextStep();
    }
  }

  async checkAllInventory() {
    const tasks = [];

    if (this.hasIngresso) tasks.push(this.updateIngressoAvailability());
    if (this.hasNights) tasks.push(this.updateNightsAvailability());
    if (this.hasHotel) tasks.push(this.updateHotelAvailability());
    if (this.hasVoo) tasks.push(this.updateVooAvailability());

    await Promise.all(tasks);
  }

  async checkVariantInventory(variantId) {
    try {
      if (this.hasIngresso) {
        const ingressoInput = this.form.querySelector(`input[name="variant_ingresso"][value="${variantId}"]`);
        if (ingressoInput) {
          return {
            id: variantId,
            available: ingressoInput.dataset.available === 'true',
            inventory_quantity: parseInt(ingressoInput.dataset.inventory) || 0
          };
        }
      }

      if (this.hasNights) {
        const nightsInput = this.form.querySelector(`input[name="nights_type"][value="${variantId}"]`);
        if (nightsInput) {
          return {
            id: variantId,
            available: nightsInput.dataset.available === 'true',
            inventory_quantity: parseInt(nightsInput.dataset.inventory) || 0
          };
        }
      }

      if (this.hasHotel) {
        const hotelVariantData = this.form.querySelector(`.hotel-variant-data[data-id="${variantId}"]`);
        if (hotelVariantData) {
          return {
            id: variantId,
            available: hotelVariantData.dataset.available === 'true',
            inventory_quantity: parseInt(hotelVariantData.dataset.inventory) || 0
          };
        }
      }

      if (this.hasVoo) {
        const vooVariantData = this.form.querySelector(`.voo-variant-data[data-id="${variantId}"]`);
        if (vooVariantData) {
          return {
            id: variantId,
            available: vooVariantData.dataset.available === 'true',
            inventory_quantity: parseInt(vooVariantData.dataset.inventory) || 0
          };
        }
      }

      const response = await fetch(`/products?variant=${variantId}&view=variant-json`);
      const data = await response.json();
      return {
        id: variantId,
        available: data.available,
        inventory_quantity: data.inventory_quantity || 0
      };
    } catch (error) {
      console.error(`Erro ao verificar estoque da variante ${variantId}:`, error);
      return {
        id: variantId,
        available: false,
        inventory_quantity: 0
      };
    }
  }

  toggleFloatingResumo() {
    const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');

    if (floatingResumo) {
      const isVisible = floatingResumo.classList.contains('show');

      if (isVisible) {
        floatingResumo.classList.remove('show');
      } else {
        floatingResumo.classList.add('show');
        this.updateFloatingSummary();
      }
    }
  }

  // Funções handle - Handle
  async handleSubmit(e) {
    e.preventDefault();

    const selectedItems = this.collectSelectedItems();
    if (selectedItems.length === 0) {
      alert('Selecione ao menos um item.');
      return;
    }

    if (!this.hasRequiredSelections()) {
      alert('Há itens obrigatórios não selecionados. Por favor, revise sua seleção.');
      return;
    }

    await this.checkAllInventory();

    if (this.hasUnavailableItems()) {
      return;
    }

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      let result;

      result = await this.addMultipleItems(selectedItems, cartDrawer);

      if (result && cartDrawer) {
        this.updateCartDrawer(cartDrawer, result);
        this.dispatchCartUpdate();
        setTimeout(() => this.reinitializeCheckoutButton(), 500);
      }

    } catch (err) {
      console.error('Erro no bundle form:', err);
      console.trace(err);
      alert('Erro ao adicionar itens ao carrinho. Tente novamente.');
    }
  }

  async handleFloatingAddToCart(e) {
    e.preventDefault();

    const selectedItems = this.collectSelectedItems();
    if (selectedItems.length === 0) {
      return;
    }

    await this.checkAllInventory();

    if (this.hasUnavailableItems()) {
      return;
    }

    const addToCartButton = e.target;
    addToCartButton.disabled = true;
    addToCartButton.textContent = 'Finalizando...';

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      let result;

      result = await this.addMultipleItems(selectedItems, cartDrawer);

      if (result) {
        if (cartDrawer) {
          this.updateCartDrawer(cartDrawer, result);
          this.dispatchCartUpdate();

          cartDrawer.open();
        }

        const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
        if (floatingResumo) {
          floatingResumo.classList.remove('show');
        }
      }

    } catch (err) {
      console.error('Erro ao adicionar ao carrinho:', err);
      alert('Erro ao adicionar itens ao carrinho. Tente novamente.');
    } finally {
      addToCartButton.disabled = false;
      addToCartButton.textContent = 'Adicionar ao Carrinho';
    }
  }
}

customElements.define('asb26-bundle-product-form', BundleForm);
